module.exports = __webpack_public_path__ + "static/media/event1.638b35c9.jpg";